import React, { useState } from 'react'
import { convertCamelCase } from '../../../helper/genericFunction'
import useCustomToast from '../../../hooks/useCustomToast';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import Icons from '../../../assets/icons';

function ScanNPackModal(props) {

    const { getRowAvailableQtyBasedOnTolerancePer, getRowTolerancePerValue } = props;

    const customToast = useCustomToast();
    const [skuWiseBoxesBackup, setSkuWiseBoxesBackup] = useState(JSON.parse(JSON.stringify(props?.skuWiseBoxes)));

    const [scanInput, setScanInput] = useState("")
    const [headers, setHeaders] = useState({
        [props.customHeader]: convertCamelCase(props?.customHeader),
        hl4Name: "Name", designNo: "Design", color: "Color", size: "Size", qty: "qty"
    });
    const [scannedData, setScannedData] = useState({});

    const scan = (e) => {
        let index = props.poDetails.findIndex(x => x[props.customHeader] === e.target.value),
            scannedDataClone = { ...scannedData };
        if(props.poDetails[index]?.isPoItemHold){
             customToast({
                title: "Error: Item on hold!",
                description: "This item is on hold",
                status: "error",
            });
            return;
        }
        else if(props.poDetails?.[index]?.tnaCompleted===false){
             customToast({
                title: "Error: TNA Pending!",
                description: "TNA of item is pending",
                status: "error",
            });
            return;
        }
        else if (props?.isEdit ? props?.isEdit && index !== -1 && +(props.poDetails[index].shipmentRequestedQty) > 0 && (props.poDetails[index].setPendingQty + getRowTolerancePerValue(props?.poDetails[index])) > 0 : index !== -1 && (props.poDetails[index].setPendingQty + getRowTolerancePerValue(props?.poDetails[index])) > 0) {
            if (props.poDetails[index][props.customHeader] in scannedDataClone) {
                if ((props.poDetails[index].setPendingQty + getRowTolerancePerValue(props?.poDetails[index])) > scannedDataClone[props.poDetails[index][props.customHeader]]) {
                    scannedDataClone[props.poDetails[index][props.customHeader]] += 1
                }
                else {
                    customToast({
                        title: "An Error Occured!",
                        description: "Quanity Not Available",
                        status: "error",
                    });
                }
            }
            else if (!(props.scanTrue && Object.keys(props.skuWiseBoxes).some(key => key !== props.poDetails[index][props.customHeader] && props.skuWiseBoxes[key][props.boxes.length - 1] !== null))) {
                scannedDataClone = { ...scannedDataClone, [props.poDetails[index][props.customHeader]]: 1 }
            }
            setScannedData(scannedDataClone);
            props.handleSKUWiseInput("e", props.poDetails[index][props.customHeader], scannedDataClone[props.poDetails[index][props.customHeader]], props.boxes.length - 1)
        }
        else {
            customToast({
                title: "An Error Occured!",
                description: "Invalid barcode or quantity not available",
                status: "error",
            });
        }
    }

    const closeAndReset = () => {
        props.discardAddSKUModal(skuWiseBoxesBackup);
    }

    const submit = () => {
        if (scannedData && Object.keys(scannedData).length) {
            props?.submit();
            props?.closeScanModal()
        }
        else {
            customToast({
                title: "An Error Occured!",
                description: "No scanned Product found",
                status: "error",
            });
        }
    }

    const deleteSku = (code) => {
        let scannedDataClone = { ...scannedData }
        delete scannedDataClone[code]
        setScannedData(scannedDataClone);
        props.deleteSku(code);
        document.getElementById("scan").focus()
    }

    return (
        <div className="box-id-generation scan-n-pack">
            <div className="ksm-head">
                <div className="ksm-left">
                    <h3>Scan and Pack</h3>
                    <p>You can scan items and directly create boxes right from here</p>
                </div>
                <div className="ksmh-right flex items-center">
                    <GenericCustomButton type='default' onClick={() => closeAndReset()} label="Discard" />
                    <GenericCustomButton type='primary' className='m-lft-15' onClick={() => submit()} label="Finish" />
                </div>
            </div>
            <div className="big-body">
                <div className="scan-item-section">
                    <div className="scan-field">
                        <div className="scm-loader" type="input"></div>
                        <input value={scanInput} id="scan" autoFocus onKeyDown={e => e.key == "Enter" ? scan(e) : null} onChange={(e) => setScanInput(e.target.value)} />
                    </div>
                    <div className="bigbfs-col">
                        <GenericCustomButton type='outline' label="New Box" leftIcon={<Icons.PlusIconBlack height={16} />}
                            onClick={() => Object.keys(scannedData).length ? props.addNewBox() :
                                customToast({
                                    title: "An Error Occured!",
                                    description: "Current box is empty",
                                    status: "error",
                                })
                            }
                        />
                        <div className='scan-details'>
                            <label>Box Number</label>
                            <p>{props.boxPrefix}/{props?.boxes?.length} </p>
                        </div>
                        <div className='scan-details'>
                            <label>Total Boxes Created</label>
                            <p>{props.boxes.length - 1}</p>
                        </div>
                    </div>
                </div>
                <div class="subscription-tab procurement-setting-tab flex relative items-center">
                    <table className="table imt-main-table">
                        <thead>
                            <tr>
                                <th><label></label></th>
                                {headers && Object.values(headers).map(header => (
                                    <th><label>{header}</label></th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {scannedData && Object.keys(scannedData).map(code =>
                                props.poDetails.map((item, index) => item[props.customHeader] == code &&
                                    <tr className='border-botTable' key={index}>
                                        <td onClick={() => deleteSku(code)}>
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.16665 5.33398H14.8333V15.6257C14.8333 15.8356 14.7499 16.037 14.6014 16.1854C14.453 16.3339 14.2516 16.4173 14.0416 16.4173H2.95831C2.74835 16.4173 2.54699 16.3339 2.39852 16.1854C2.25005 16.037 2.16665 15.8356 2.16665 15.6257V5.33398ZM3.74998 6.91732V14.834H13.25V6.91732H3.74998ZM6.12498 8.50065H7.70831V13.2507H6.12498V8.50065ZM9.29165 8.50065H10.875V13.2507H9.29165V8.50065ZM4.54165 2.95898V1.37565C4.54165 1.16569 4.62505 0.964324 4.77352 0.815858C4.92199 0.667392 5.12335 0.583984 5.33331 0.583984H11.6666C11.8766 0.583984 12.078 0.667392 12.2264 0.815858C12.3749 0.964324 12.4583 1.16569 12.4583 1.37565V2.95898H16.4166V4.54232H0.583313V2.95898H4.54165ZM6.12498 2.16732V2.95898H10.875V2.16732H6.12498Z" fill="#111D31" />
                                            </svg>
                                            <span className='generic-tooltip'>Delete</span>
                                        </td>
                                        {Object.keys(headers).map(head => <td><label>{head == "qty" ? scannedData[code] : item[head]}</label></td>)}
                                    </tr>
                                )
                            )}
                        </tbody>
                        <tfoot>
                            <tr className='create-items-footer'>
                                <td colspan="11" ><label>Total added Items: <span>{Object.keys(scannedData).length}</span></label></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ScanNPackModal